import React from 'react';
import styled from 'styled-components';

interface TaskResultSummaryProps {
    successful: number;
    failed: number;
    total: number;
    className?: string;
    labels?: {
        successful?: string;
        failed?: string;
        total?: string;
    };
}

const ResultCell = styled.div`
    display: flex;
    gap: 12px;
    font-size: 12px;
    align-items: center;
`;

const ResultItem = styled.span<{ color?: string }>`
    color: ${(props) => props.color || 'inherit'};
    font-weight: ${(props) => props.theme.font.medium};
    display: flex;
    align-items: center;
    gap: 4px;
`;

const Icon = styled.span`
    font-size: 14px;
`;

/**
 * TaskResultSummary - Atomic component for displaying task result statistics
 * Can be used for any type of task that has success/failure counts
 */
export const TaskResultSummary: React.FC<TaskResultSummaryProps> = ({ successful, failed, total, className, labels }) => {
    return (
        <ResultCell className={className}>
            <ResultItem color='#388e3c'>
                <Icon>✓</Icon>
                {successful} {labels?.successful || ''}
            </ResultItem>
            <ResultItem color={failed > 0 ? '#d32f2f' : 'inherit'}>
                <Icon>✗</Icon>
                {failed} {labels?.failed || ''}
            </ResultItem>
            <ResultItem>
                / {total} {labels?.total || ''}
            </ResultItem>
        </ResultCell>
    );
};

export default TaskResultSummary;
